export const CYBERSECURITY_INDICATORS = {
  TITLE: 'Cybersecurity Indicators',
  INDICATORS: {
    protectedDevices: 'Protected Devices',
    managedExposedCredentials: 'Managed Exposed Credentials',
    compliantEmployees: 'Compliant Employees',
  },
  ON_TRACK: 'On Track',
  NEEDS_ATTENTION: 'Needs Attention',
  PROGRESS: (completed: number, total: number) => `${completed} of ${total} items`,
}
